/* src/app/system-utils/task-processor/task-processor.component.scss */
textarea {
  height: 100% !important;
  overflow: auto;
  width: 100%;
  font-size: 10px;
  resize: none;
}
.pb-content {
  margin-bottom: 10px;
}
.content {
  height: 400px;
  width: 100%;
  display: flex;
  padding: 10px;
  flex-direction: column;
  gap: 10px;
  font-family: var(--tem-font-family);
}
.content h4 {
  margin: 0;
  color: var(--tem-ink);
}
.text-content {
  height: 100%;
  width: 100%;
}
.button-content {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.spacer {
  flex: 1;
}
/*# sourceMappingURL=task-processor.component.css.map */
